/**
 * 从数组中随机获取指定数量的元素，排除已存在的数据
 * @param array 输入数组
 * @param count 要获取的元素数量
 * @param excludeItems 已存在的元素数组，用于排除
 * @returns 随机选取的元素数组
 */
export const getRandomItems = <T>(
  array: T[],
  count: number,
  excludeItems: T[] = []
): T[] => {
  // 输入验证
  if (!Array.isArray(array) || count < 0 || !Array.isArray(excludeItems)) {
    return [];
  }

  // 过滤掉已存在的元素（使用 JSON 序列化比较）
  const filteredArray = array.filter((item) => {
    const itemStr = JSON.stringify(item);
    return !excludeItems.some(
      (excludeItem) => JSON.stringify(excludeItem) === itemStr
    );
  });

  // 检查过滤后的数组是否足以提供所需数量
  if (count > filteredArray.length) {
    return [];
  }

  // 复制数组以避免修改原数组
  const tempArray = [...filteredArray];
  const result: T[] = [];

  // 随机选取 count 个元素
  for (let i = 0; i < count; i++) {
    const randomIndex = Math.floor(Math.random() * tempArray.length);
    result.push(tempArray[randomIndex]);
    tempArray.splice(randomIndex, 1);
  }

  return result;
};
/**
 * 生成 200 到 450 之间的随机整数（包含边界）
 * @returns 随机整数
 */
export const getRandomValue = (): number => {
  return Math.floor(Math.random() * (450 - 200 + 1)) + 200;
};

// 随机从数组中取一个元素的函数
export const getRandomItem = <T extends any>(
  array: T[] | null | undefined
): T | undefined => {
  if (!Array.isArray(array) || array.length === 0) {
    console.warn("getRandomItem: Input is not a valid non-empty array", array);
    return undefined;
  }
  const randomIndex = Math.floor(Math.random() * array.length);
  return array[randomIndex];
};

export const toPascalCase = (input: string | string[]): string => {
  if (!input) {
    return "";
  }

  let words: string[];

  // Handle string or array input
  if (typeof input === "string") {
    // Remove special characters and split into words
    const cleanInput = input.replace(/[^a-zA-Z0-9\s]/g, "").trim();
    if (!cleanInput) {
      return "";
    }
    words = cleanInput.split(/\s+/);
  } else {
    // Input is an array; filter out invalid entries
    words = input.filter(
      (word) => typeof word === "string" && word.trim() !== ""
    );
  }

  // Convert to PascalCase
  return words
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join("");
};

export const parseAndAppendSupportCode = (errorMessage: string) => {
  const regex = /\d{8}/;
  const supportCodeIndex = errorMessage.indexOf("Support codes:");
  if (supportCodeIndex === -1) return undefined;
  const afterSupportCodes = errorMessage.slice(
    supportCodeIndex + "Support codes:".length
  );
  const match = afterSupportCodes.match(regex);
  return match ? match[0] : undefined;
};
